// frontend/src/api/CNAuBTRIBICFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNAuBTRIBICFiles = async () => {
  try {
    const response = await api.get("/cna-ub-tribic-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA uB TRIBIC file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNAuBTRIBICFileById = async (id) => {
  try {
    const response = await api.get(`/cna-ub-tribic-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA uB TRIBIC file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNAuBTRIBICFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-ub-tribic-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNAuBTRIBICFiles = async (query) => {
  try {
    const response = await api.get(`/cna-ub-tribic-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA uB TRIBIC files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNAuBTRIBICFile = async (data) => {
  try {
    const response = await api.post("/cna-ub-tribic-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA uB TRIBIC file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNAuBTRIBICFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-ub-tribic-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA uB TRIBIC file ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNAuBTRIBICFile = async (id) => {
  try {
    const response = await api.delete(`/cna-ub-tribic-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA uB TRIBIC files:", error);
    throw error;
  }
};

// Exportar archivos por nombre
/*export const exportCMAMTOFERDAFilesByName = async (namesArray) => {
  try {
    const namesParam = namesArray.map(encodeURIComponent).join(",");
    const response = await api.get(`/cmam-toferda-files/export/?names=${namesParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CMAM TOFERDA files by name:", error);
    throw error;
  }
};*/

// Exportar archivos por ID
export const exportCNAuBTRIBICFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-ub-tribic-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA uB TRIBIC file by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNAuBTRIBICFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-ub-tribic-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA uB TRIBIC files:", error);
    throw error;
  }
};
